import { Language, Translation } from "@/types/language.types";

class TranslationService {
  async get<T extends { [key: string]: string }>(
    messages: T,
    lang: Language | null
  ): Promise<Translation<T>> {
    // Se não há idioma especificado, retorna as mensagens padrão
    if (!lang) {
      return messages as Translation<T>;
    }

    // Para o Vite, vamos retornar as mensagens diretamente
    // No futuro, pode ser implementada lógica de tradução dinâmica
    return messages as Translation<T>;
  }

  // Método para obter mensagens com fallback
  async getWithFallback<T extends { [key: string]: string }>(
    messages: T,
    lang: Language | null,
    fallbackLang: Language = "PT-BR"
  ): Promise<Translation<T>> {
    try {
      const result = await this.get(messages, lang);
      return result;
    } catch (_error) {
      // fallback silencioso
      return await this.get(messages, fallbackLang);
    }
  }
}

const translationService = new TranslationService();
export default translationService;
